import {
  useAirportConsumptionRpt,
  useAirportConsumptionRptExport,
} from '@services/report'
import Flex from '@shared/Flex'
import { Button } from '@shared/Form'
import useSearch from '@shared/innmaxLib/hooks/useSearch'
import { RangePicker } from '@shared/innmaxUI/Form/DatePicker'
import Layout from '@shared/Layout'
import Table from '@shared/Table'
import { downloadFile } from '@shared/utils/webHelper'
import { Form } from 'antd'
import { ColumnsType } from 'antd/es/table'
import moment from 'moment'
import { isNil } from 'ramda'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormItem } from 'src/components/Form'

const initialReportType = {
  startAt: moment().startOf('month').valueOf(),
  endAt: moment().endOf('month').valueOf(),
}

function ConsumptionReport() {
  const { t } = useTranslation()

  const [form] = Form.useForm()

  const { query, handleSearch, handleTableChange } = useSearch({
    form,
    initial: initialReportType,
    dateRangeField: ['startAt', 'endAt'],
  })

  const [exporting, handleExport] = useAirportConsumptionRptExport(query, {
    onSuccess: (blob: any) => {
      downloadFile({
        blob,
        filename: 'OperationReport',
      })
    },
  })

  const { dataSource, loading } = useAirportConsumptionRpt(query)

  const columns: ColumnsType<any> = [
    {
      title: '日期',
      dataIndex: 'date',
      align: 'center',
    },
    {
      title: '故障次數',
      dataIndex: 'faultCount',
      align: 'center',
    },
    {
      title: '充電費',
      dataIndex: 'properRate',
      align: 'center',
      render: v => (isNil(v) ? '-' : v * 100),
    },
    {
      title: '使用次數',
      dataIndex: 'usageCount',
      align: 'center',
    },
    {
      title: '使用率',
      dataIndex: 'usageRate',
      align: 'center',
      render: v => (isNil(v) ? '-' : v * 100),
    },
  ]

  return (
    <>
      <Layout>
        <Form layout="inline" form={form}>
          <FormItem
            label={'時間範圍'}
            name="date"
            initialValue={[
              moment(initialReportType.startAt),
              moment(initialReportType.endAt),
            ]}>
            <RangePicker />
          </FormItem>

          <FormItem.Button>
            <Button
              loading={false}
              type="primary"
              className="w-96"
              onClick={handleSearch}>
              {t('common:search')}
            </Button>
          </FormItem.Button>
          <FormItem.Button>
            <Button
              loading={exporting}
              type="primary"
              ghost
              className="w-96"
              onClick={handleExport}>
              {t('report:export')}
            </Button>
          </FormItem.Button>
        </Form>

        {/* {renderStatusContent()} */}
        <div className="mt-44 mb-16">
          <Flex between>
            <Table.RowCount count={dataSource?.total || 0} />
          </Flex>
        </div>
        <Table
          simpleMode
          columns={columns}
          loading={loading}
          dataSource={dataSource}
          onChange={handleTableChange}
          pagination={false}
        />
      </Layout>
    </>
  )
}

export default React.memo(ConsumptionReport)
